import * as React from "react";
import s from "./footer.scss";
import ZigLogo from "#components/primitive/menu/v2/logo.svg";

export function Footer() {
	return (
		<footer className={s.footer}>
			<div className={s.footerContent}>
				<div className={s.footerLogoWrapper}>
					<ZigLogo />
				</div>
			</div>
		</footer>
	);
}
